function ImageLoader({ imagesLoaded, totalImages }) {
  return (
    <div className="loading-screen">
      <div className="loading-bar">
        <div className="loading-bar-progress" style={{ width: `${(imagesLoaded / totalImages) * 100}%` }}></div>
      </div>
    </div>
  );
}

export default ImageLoader;
